export default {"src":"/_next/static/media/steem.6f808922.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};